import { contains } from 'ramda';

export const hasEventsAccess = (user, worksheet) => {
    const userParticipant = worksheet.eventsUsersIds && contains(user.id, worksheet.eventsUsersIds);

    return userParticipant && !worksheet.eventsDisabled;
};
